import { css } from '@emotion/react';
import { useTranslation } from '@frontend/i18n';
import { theme } from '@frontend/theme';
import { Chip, Text } from '@frontend/design-system';

interface Props {
  count: number;
}

export const SlotCount = ({ count }: Props) => {
  const { t } = useTranslation('calendar-grid');
  const hasSlots = count > 0;

  return (
    <div css={containerStyle}>
      <Chip size='tiny' variant={hasSlots ? 'primaryDark' : 'neutral'} css={chipStyle}>
        {count}
      </Chip>
      <Text as='span' size='small' color={hasSlots ? 'default' : 'subdued'}>
        {t('Slots', { count })}
      </Text>
    </div>
  );
};

const containerStyle = css({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: theme.spacing(0.5),
  padding: theme.spacing(0.5),
  containerType: 'inline-size',
  '@container (width < 90px)': {
    '> span': {
      display: 'none',
    },
  },
});

const chipStyle = css({
  '> span': {
    fontWeight: theme.font.weight.bold,
  },
});
